'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getCategories(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `categories${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getCategory(id) {
    const data = {
      method: 'get',
      url: 'category/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createCategory(json) {
    const data = {
      method: 'post',
      url: 'category',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Category created successfully')
      return true;
    }
  },
  async updateCategory(json, id) {
    const data = {
      method: 'put',
      url: 'category/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Category updated successfully')
      return true;
    }
  },
  async getProductsByCategory(id) {
    const data = {
      method: 'get',
      url: 'category/' + id + '/products',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async deleteCategory(id) {
    const data = {
      method: 'delete',
      url: 'category/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Category deleted successfully')
      return true
    }
  },
}
